import { marker } from '@ngneat/transloco-keys-manager/marker';

import { sharedI18nKeys } from '@cjm/shared/i18n';

export const I18nKeys = {
	...sharedI18nKeys,
	Results: {
		AccessibleTitle: marker('results.accessible-title'),
		SingleResult: marker('results.single-result'),
		MultipleResults: marker('results.multiple-results'),
		SingleResultWoAmount: marker('results.single-result-wo-amount'),
		MultipleResultsWoAmount: marker('results.multiple-results-wo-amount'),
		NoResults: marker('results.no-results'),
		Of: marker('results.of')
	},
	Hamburger: {
		Title: marker('hamburger.title')
	},
	Link: {
		Accessibility: {
			ExternalLink: marker('link.accessibility.external-link'),
			OpensOnNewTab: marker('link.accessibility.opens-in-new-tab'),
			OpensInThisTab: marker('link.accessibility.opens-in-this-tab')
		}
	},
	SkipLinks: {
		MainContent: marker('skip-links.main-content'),
		Footer: marker('skip-links.footer')
	},
	ProgressMeter: {
		Step: marker('progress-meter.step')
	},
	Pagination: {
		PreviousPage: marker('pagination.previous-page'),
		NextPage: marker('pagination.next-page'),
		MoveToPage: marker('pagination.move-to-page')
	},
	Modals: {
		SessionExpired: {
			Title: marker('modals.session-expired.title'),
			Message: marker('modals.session-expired.message'),
			Buttons: {
				LogIn: {
					Text: marker('modals.session-expired.buttons.log-in.text'),
					Title: marker('modals.session-expired.buttons.log-in.title')
				},
				Cancel: {
					Text: marker('modals.session-expired.buttons.cancel.text'),
					Title: marker('modals.session-expired.buttons.cancel.title')
				}
			}
		}
	}
};
